import React from "react"
import Header from "../header/Header"

const Layout = (props: any) => {
	return (
		<div>
			<Header />
			<div className="content">{props.children}</div>
		</div>
	)
}

export default Layout
